import { gql } from "@apollo/client"

export const UPDATE_TERMINAL_NICKNAME = gql`
  mutation updateTerminalNickName($id: ID!, $nickname: String!) {
    updateTerminalNickname(id: $id, nickname: $nickname) {
      terminal {
        nickname
      }
    }
  }
`
